import React, { useMemo } from 'react';

import { RLLComputedProfitabilityPresalesTopBoxes } from 'models/types/Profitability.type';
import { useTranslations } from 'utils/hooks/useTranslations';

import { getData } from './module';
import ProjectCostingBoxes from '../../../../SharedComponent/ProjectCostingBoxes';

interface PresalesTopBoxesProps {
  topBoxes: RLLComputedProfitabilityPresalesTopBoxes;
}

export const PresalesTopBoxes: React.FC<PresalesTopBoxesProps> = ({ topBoxes }) => {
  const t = useTranslations();
  const data = useMemo(() => getData(t, topBoxes), [t, topBoxes]);

  return <ProjectCostingBoxes values={data} />;
};
